import React from "react";
import { useParams } from "react-router-dom";
import Navbar from "./Navbar";
import Filter from "./Filter";
import CategoryProductRow from "../components/CategoryProductRow";

function CategoryPage(){
    const params = useParams();
    const {category} = params;
    return(
        <div>
            <Navbar />
            <div className='ms-3 my-3'>
                <h2>{category}</h2>
            </div>
            <div className="row">
                <div className="col-3 px-0 bg-white">
                    <Filter/>
                </div>
                <div className="col-9 bg-grey">
                    <div className="row">
                        <div className="col-11">
                            <CategoryProductRow/>
                        </div>
                        <div className="col-11">
                            <CategoryProductRow/>
                        </div>
                        <div className="col-11">
                            <CategoryProductRow/>
                        </div>
                        <div className="col-11">
                            <CategoryProductRow/>
                        </div>
                        <div className="col-11">
                            <CategoryProductRow/>
                        </div>
                    </div>
                </div>
                {/* <div className="col-1 py-4">
                    <select className="form-select d-block mb-2" aria-label="Default select example">
                        <option selected>Price low to High</option>
                        <option value="1">Price High to Low</option>
                        <option value="2">Recently listed</option>
                    </select>
                </div> */}
            </div>
        </div>
    )
}

export default CategoryPage;